import { PhotoTool } from "components/Photos";
import React from "react";
import { connect } from "react-redux";

interface PhotoPopOutContainerProps {
  controlNumber: number;
}

const PhotoPopOutContainer = ({ controlNumber }: PhotoPopOutContainerProps) => {
  return (
    <PhotoTool
      controlNumber={controlNumber}
      isPopOutWindow
    />
  );
};

const mapStateToProps = state => {
  return {
    controlNumber: state.caseDetails.controlNumber,
  };
};

export default connect(mapStateToProps)(PhotoPopOutContainer);
